export interface Productos {
    id:string,
    nombre:string,
    price:number,
    stock:number,
    status:string,
    categoria_id:string,
    description:string,

}
export interface ProductosResponse{
    id:string;
   nombre:string;
    price:number;
    stock:number;
    status:string;
    description:string | null;
    category:string |null;
    imagenes:string [];
}
export interface ProductosRequest{
    nombre:string,
    price:number,
    stock:number,
    description:string |null,
    categoryName:string,
    imagenes:FileRequest[],
}
export interface UpdateProductsRequest{
    nombre:string | null;
    price:number | null;
    stock:number | null;
    status:string | null;
    description:string | null;
    categoryName:string | null;
    imagenesNuevas:FileRequest[] | null;
}
export interface FileRequest{
    base64:string
}
export interface ProductosState {
    products: ProductosResponse[];
}

export const SET_PRODUCTS = 'SET_PRODUCTS';

export interface SetProductsAction {
    type: typeof SET_PRODUCTS;
    payload: ProductosResponse[];
}

export type ProductosActionTypes = SetProductsAction;